import axios from "./axios";

function create(data) {
    return axios().post(`/warehouses/${data.warehouse_id}/items/${data.item_id}`, data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    })
}

function findByID({warehouseId, itemId}) {
    return axios().get(`/warehouses/${warehouseId}/items/${itemId}`)
}

function remove(data) {
    return axios().delete(`/warehouses/${data.warehouse_id}/items/${data.item_id}`)
}

function update(data) {
    return axios().put(`/warehouses/${data.warehouse_id}/items/${data.item_id}`, data);
}

function list(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.itemsPerPage;
    return axios().get(`/warehouses/${params.warehouse_id}/items`, { params })
}

export default {
    create,
    findByID,
    remove,
    update,
    list
}